import { SyntheticEvent } from "react";
import { LatLngTuple } from "leaflet";
// External Imports ----------------------------------------------------
import { FixedSizeList as List } from "react-window";
import OriginSelect from "react-select";
import axios, { ResponseType, GenericAbortSignal } from "axios";
//import qs from "querystring"; deprecated
//Internal Imports -----------------------------------------------------
import locating from "src/img/maps/locating.png";
import potholing from "src/img/maps/potholing.png";
import GRP from "src/img/maps/GPR.png";
import cctvimg from "src/img/maps/cctv.png";
import mappingimg from "src/img/maps/mapping.png";
import tcimg from "src/img/maps/tc.png";
import bessLogoImg from "src/img/bessutilitysolutionslogo.png";
import jmbLogoImg from "src/img/jmblogo.png";
import { json, jsonArr, simple, ss } from "./types";
import { user } from "src/components/login/login";
import { getAccessToken, setAccessToken, clearAccessToken } from "src/components/common/authToken";
import { useMyStore } from "src/components/main/mainStore";
//ComponentType<MenuListProps<unknown, false, GroupBase<unknown>>> | undefined'.
// Constants -----------------------------------------------------
// Hostname-keyed brand flag/title, same pattern as apiUrlMap/getBrandLogo —
// plain constants so existing consumers need no changes; hostname doesn't
// change during a page session. localhost / Bess hosts stay Bess.
export const isJmbBrand = window.location.hostname === "app.jmbnexlvl.com";
export const appTitle = isJmbBrand ? "JMB Nex LVL" : "Bess Utility Solutions";
export const isDevMode = process.env.NODE_ENV === "development";
export const universityProjectHashKey = "95325bbb02fe33ec16f2d1c272b6f09c";
export const regionOptions = [
    "North California", 
    "South California", 
    "Arizona",
    "Nevada"
];
export const pipelineOptions = {
    "Locating Project": [
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Potholing Project": [
        "Traffic Control Plans", 
        "Permits", 
        "USA Delineation", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "GPR Concrete Scanning and Coring Project": [
        "Work In Progress", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "CCTV Project": [
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Mapping Project": [
        "Work In Progress", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Traffic Control Project": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Hydrovac Excavation Project": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Saw Cutting Project": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Straight Vacuum Service": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
}
export const subPipelineOptions = {
    "CCTV Project": [
        "NASSCO",
        "LOCATE" 
    ]
}
export const projectCategoryColorCode = {
    "Potholing Project": {rgb: [158, 105, 175], title: "Potholing", icon: potholing}, 
    "Locating Project": {rgb: [244, 81, 30], title: "Locating", icon: locating}, 
    "Mapping Project": {rgb: [142, 36, 170], title: "Mapping", icon: mappingimg}, 
    "CCTV Project": {rgb: [63, 81, 181], title: "CCTV", icon: cctvimg}, 
    "GPR Concrete Scanning and Coring Project": {rgb: [213, 0, 0], title: "GPR Concrete Scanning and Coring", icon: GRP}, 
    "Traffic Control Project": {rgb: [246, 191, 38], title: "Traffic Control", icon: tcimg},
    "Hydrovac Excavation Project": {rgb: [191, 246, 38], title: "HydroVac", icon: tcimg}, 
    "Saw Cutting Project": {rgb: [128, 128, 128], title: "Saw Cutting", icon: tcimg}, 
    "Straight Vacuum Service": {rgb: [128, 64, 128], title: "Straight Vacuum", icon: tcimg},
};
export const fileSystemSchemaForProjects = [
    {"name": "contracts", "title": "Contracts", "folderIdLabel": "contractsFolderId", "folderKey": "contractsFiles"},
    {"name": "emailRecords", "title": "Email Records", "folderIdLabel": "emailRecordsFolderId", "folderKey": "emailRecordsFiles"},
    {"name": "otherAttachments", "title": "Other Documents (Any Important Job Related Documents)", "folderIdLabel": "otherAttachmentsFolderId", "folderKey": "otherAttachmentsFiles"},
    {"name": "techniciansAttachments", "title": "Dispatch Documents (Exhibits, Traffic Plans, USA Tickets) (Visible To All Of This Project Techs)", "folderIdLabel": "techAttachmentsFolderId", "folderKey": "techFiles"},
];
export const poApproverMap = isJmbBrand ? {
    "Outside Service Expense": "michael@jmbnexlvl.com",
    "Office Supply": "michael@jmbnexlvl.com",
    "Vehicle Maintenance": "michael@jmbnexlvl.com",
    "Equipment Expense": "michael@jmbnexlvl.com",
    "Equipment Maintenance": "michael@jmbnexlvl.com",
    "Yard Material": "michael@jmbnexlvl.com",
    "Vehicle Rental": "michael@jmbnexlvl.com",
    "Traffic Control Related": "michael@jmbnexlvl.com",
    "Subscription": "michael@jmbnexlvl.com",
    "In-House Training": "michael@jmbnexlvl.com",
    "QA/QC": "michael@jmbnexlvl.com",
    "Marketing": "michael@jmbnexlvl.com",
    "Safety": "michael@jmbnexlvl.com",
    "Accommodation": "michael@jmbnexlvl.com",
    "Saw Cutting": "michael@jmbnexlvl.com",
    "Scanning & Coring Materials": "michael@jmbnexlvl.com",
} : {
    "Outside Service Expense": "armando@besstestlab.com",
    "Office Supply": "lyn@besstestlab.com",
    "Vehicle Maintenance": "michael@besstestlab.com",
    "Equipment Expense": "michael@besstestlab.com",
    "Equipment Maintenance": "michael@besstestlab.com",
    "Yard Material": "michael@besstestlab.com",
    "Vehicle Rental": "michael@besstestlab.com",
    "Traffic Control Related": "michael@besstestlab.com",
    "Subscription": "michael@besstestlab.com",
    "In-House Training": "michael@besstestlab.com",
    "QA/QC": "armando@besstestlab.com",
    "Marketing": "michael@besstestlab.com",
    "Safety": "michael@besstestlab.com",
    "Accommodation": "michael@besstestlab.com", 
    "Saw Cutting": "michael@besstestlab.com", 
    "Scanning & Coring Materials": "michael@besstestlab.com", 
};
export const paymentMethodList = [
    "Pay by American Express card", 
    "Pay by company account",
    "Pay by personal account",
    "Pay by Mastercard 5872", 
    "Pay by Costco Visa Card",
    "Pay By Master Card 6485",
    "Pay By Citi Card 2990",
    "Pay By card 9089",
    "Pay By Master Card 1365",
    "Pay By AMEX Card 5593"
]
export const additionalJobTagApproverEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "yan@besstestlab.com", 
    "gloria@besstestlab.com"
];
export const defaultPOApproverEmail = isJmbBrand
    ? "michael@jmbnexlvl.com"
    : "michael@besstestlab.com";
export const defaultEmptyDate = "0000-00-00";
export const defaultEmptyDateTime = "0000-00-00 00:00:00";
export const defaultEmptyTime = "00:00:00";
export const defaultEmptyPMNumber = "00000000";
export const outsideWorkingOns = [
    "PGE 1st Party Locate", 
    "PGE 2nd Party Locate", 
    "PGE 1st Party Standby", 
    "PGE 2nd Party Standby", 
    "3rd Party Standby", 
    "Running a self populated folder", 
    "Training"
];
export const testerEmails = [
    "jmorrow@tech2u.com"
];
export const restDayProjectHashKey = isJmbBrand
    ? ""
    : "15af4cccebaa9dbfc8b5d9fb2057da70";
export const outsideNotWorkingReasons = [
    "No Work", 
    "Sick",
    "Injured", 
    "Training", 
    "Vacation"
];
export const jsaManagers = isJmbBrand ? [
    {name: "Michael Bohorquez", email: "michael@jmbnexlvl.com", tel: ""},
] : [
    {name: "Danny RedMond", email: "dredmond@besstestlab.com", tel: "916-308-6691"},
];
export const projectAdmins = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "jmorrow@tech2u.com",
    "yanderline@jmbnexlvl.com",
] : [
    "jmorrow@tech2u.com",
    "dredmond@besstestlab.com",
    "cristina@besstestlab.com",
    "michael@besstestlab.com"
];
export const jsaOnsiteNumbers = isJmbBrand ? [
    "000-000-0000"
] : [
    "866-523-8046"
];
export const outsideCordinators = isJmbBrand ? [
    {name: "Michael Bohorquez", email: "michael@jmbnexlvl.com"}
] : [
    {name: "Kayte", email: "west-piper@besstestlab.com"}
];

export const locatingReportWriterEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "danielc@besstestlab.com", 
    "jareth@besstestlab.com", 
    "klay@besstestlab.com", 
    "erodriguez@bessus.com"
];
export const potholingReportWriterEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "jmaciel@besstestlab.com", 
    "yrodriguez@besstestlab.com", 
    "arubio@besstestlab.com", 
    "vdelgado@besstestlab.com",
    // "jmorrow@tech2u.com" //remove after testing or switch to DB based lists
];
export const CCTVReportWriterEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "uriel@besstestlab.com"
];
export const reportWriterEmails = [
    ...locatingReportWriterEmails, 
    ...potholingReportWriterEmails, 
    ...CCTVReportWriterEmails
];
export const calibrationVerificationFormApprovers = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "mireya@besstestlab.com"
];
export const auditFormApprovers = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "abaggett@besstestlab.com"
];
export const standbyExceptionEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "r.johnson@besstestlab.com"
];
export const billingManagerEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "lyn@besstestlab.com"
];
export const billingMemberEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "francesca@besstestlab.com"
];
export const billingEmails = [
    ...billingManagerEmails, 
    ...billingMemberEmails
];
export const laborCostUploaderEmailList = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "yan@besstestlab.com",
    "gloria@besstestlab.com",
];
export const BillingUploaderEmailList = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "lyn@besstestlab.com",
    "francesca@besstestlab.com"
];
export const runnerExceptionEmailList = isJmbBrand ? [] : [
    "ibaltodano@besstestlab.com",
    "hmin@besstestlab.com"
];
export const locatorExceptionsList = isJmbBrand ? [] : [
    "fred@besstestlab.com",
    "rthiede@besstestlab.com"
];
export const outsideStatusExceptions = isJmbBrand ? [] : [
    "r.johnson@besstestlab.com"
];
export const exclusiveOutisdeKeys = [
    "email", 
    "lanId", 
    "employee_id",
    "hireDate",
    "quitDate", 
    "outside", 
    "outsideTimeCards", 
    "userName", 

    "residenceState", 
    "residence", 
    "street", 
    "zipCode", 
    "phoneNumber", 
    "firstName",
    "lastName",
];
export const LMStatusOpts = {
    Ongoing: [
        "Work Ongoing", 
        "Electrical Hook Up Points", 
        "Phase Ticket", 
        "Negotiate New Start", 
        "No Delineation (Ongoing)", 
        "Excavated Before Marked (Ongoing)", 
        "Attempted to Contact Excavator"
    ],
    Complete: [
        "Facilities Marked", 
        "No Conflict", 
        "No Conflict (Screened)", 
        "No Delineation (Complete)", 
        "No Excavation to Take Place", 
        "No Remark Required", 
        "Located by PG&E Crew", 
        "Bad Ticket Info", 
        "Excavated Before Marked", 
        "No Access to Delineated Area (0/3)"
    ]
};
/*
<option>Ongoing</option>
<option>Bad info</option>
<option>Phased</option>
<option>Cancelled ticket</option>
<option>Negotiate New Start</option>
<option>Excavated Before Marked</option>
<option>Attempted to Contact Excavator</option>
<option value = "IP">In Progress</option>
<option value = "MK">Marked</option>
<option value = "NC">No Conflict</option>
<option value = "NA">No Access</option>
<option value = "ND">No Delineation</option>
<option value = "CFO">Cleared From Office</option>
*/

export const weekDays = [
    "Monday", 
    "Tuesday", 
    "Wednesday", 
    "Thursday", 
    "Friday", 
    "Saturday", 
    "Sunday", 
];
export const month = [
    "January", 
    "February", 
    "March", 
    "April", 
    "May", 
    "June", 
    "July", 
    "August", 
    "September", 
    "October", 
    "November", 
    "December", 
];
export const mon = [
    "Jan", 
    "Feb", 
    "Mar", 
    "Apr", 
    "May", 
    "Jun", 
    "Jul",
    "Aug", 
    "Sep", 
    "Oct", 
    "Nov", 
    "Dec", 
];
export const defaultEmptyLocatorDataString = JSON.stringify({
    "form": Array(7).fill({
        "data": [], 
        "status": "Created", 
        "overnight": false
    })
});
export const emailsListFor1245Exception5x8 = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "abaggett@besstestlab.com",
    "dredmond@besstestlab.com",
    "r.johnson@besstestlab.com",

    "jeverly@besstestlab.com",

    "jcockburn@besstestlab.com",
    // "terrance@besstestlab.com",
    // "valente@besstestlab.com",
    "tom@besstestlab.com",

    "enriquegarcia@besstestlab.com",
];
export const pmEmails = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "armando@besstestlab.com", 
    "dredmond@besstestlab.com",
    "r.johnson@besstestlab.com"
];
interface mimeTypeMapType {
    "txt": "text/plain", 
    "xml": "text/xml",
    "kml": "application/vnd.google-earth.kml+xml", 
    "pdf": "application/pdf", 
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
    "xlsm": "application/vnd.ms-excel.sheet.macroenabled.12", 
    "xls": "application/vnd.ms-excel", 
    "csv": "text/csv", 
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
    "xps": "application/vnd.ms-xpsdocument", 
    "docm": "application/vnd.ms-word.document.macroenabled.12", 
    "doc": "application/msword", 
    "accdb": "application/msaccess", 
    "msg": "application/vnd.ms-outlook", 
    "rtf": "application/rtf", 
    "png": "image/png", 
    "jpg": "image/jpeg", 
    "jpeg": "image/jpeg", 
    "svg": "image/svg+xml", 
    "gif": "image/gif", 
    "bmp": "image/bmp", 
    "mp3": "audio/mpeg", 
    "mp4": "video/mp4", 
    "zip": "application/x-zip-compressed", 
    "json": "application/json",
    "folder": "application/vnd.google-apps.folder",
    "document": "application/vnd.google-apps.document"
    //application/octet-stream
}
export const mimeTypeMap: mimeTypeMapType = {
    "txt": "text/plain", 
    "xml": "text/xml",
    "kml": "application/vnd.google-earth.kml+xml", 
    "pdf": "application/pdf", 
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
    "xlsm": "application/vnd.ms-excel.sheet.macroenabled.12", 
    "xls": "application/vnd.ms-excel", 
    "csv": "text/csv", 
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
    "xps": "application/vnd.ms-xpsdocument", 
    "docm": "application/vnd.ms-word.document.macroenabled.12", 
    "doc": "application/msword", 
    "accdb": "application/msaccess", 
    "msg": "application/vnd.ms-outlook", 
    "rtf": "application/rtf", 
    "png": "image/png", 
    "jpg": "image/jpeg", 
    "jpeg": "image/jpeg", 
    "svg": "image/svg+xml", 
    "gif": "image/gif", 
    "bmp": "image/bmp", 
    "mp3": "audio/mpeg", 
    "mp4": "video/mp4", 
    "zip": "application/x-zip-compressed", 
    "json": "application/json",
    "folder": "application/vnd.google-apps.folder",
    "document": "application/vnd.google-apps.document"
    //application/octet-stream
};
export const mimeTypeMapReverse /* mimeTypeMap */ = Object.fromEntries(Object.entries(mimeTypeMap).map(([key, value]) => [value, key]));
export const outsideRoleCode = {
    "locator": "CURRENT PG&E Locate & Mark/USAs", 
    "standby": "Gas Standby", 
    "qew": "Qualified Electrical Worker (QEW)"
};
export const simpleStatusColorCode = {
    "Created": "red", 
    "Saved": "orange",
    "Submitted": "purple", 
    "Re-Submitted": "black", 
    "Approved": "green",
    "Rejected": "gray",
    "Completed": "green"
};
export const simpleStatusColorCodExcelHex = {
    "Created": "FF0000", 
    "Submitted": "800080", 
    "Approved": "00FF00",
    "Rejected": "808080"
};
export const locatingApproval = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "mireya@besstestlab.com",
    "neyda@besstestlab.com"
];
export const scanningApproval = isJmbBrand ? [
    "michael@jmbnexlvl.com",
    "yanderline@jmbnexlvl.com",
] : [
    "jeverly@besstestlab.com",
];
export const OfficesLocationMap:{
    [key: string]: LatLngTuple 
} = {
    "Hayward Office": [37.61498, -122.08525], // 2463 Tripaldi Way, Hayward, CA 94545
    "Sacramento Office": [38.52465, -121.39588], // 18 Business Park Way, Sacramento, CA 95828
    "Fresno Office": [36.79860, -119.85823], // 4284 N Knoll Ave., Fresno, CA 93722
    "Ontario Office": [34.041040, -117.619390], // 1508 E Francis St, Ontario, CA 91761
    "Fremont Yard": [37.496590, -121.929090] // 801 Boggs Ave., Fremont, CA 94539
}
export const isMobilePhone = (navigator as json).userAgentData?.mobile ?? ((navigator.userAgent.toLowerCase().search("mac") > -1) || (navigator.userAgent.toLowerCase().search("iphone") > -1) || (navigator.userAgent.toLowerCase().search("android") > -1));
export const localWeekDays = [...weekDays.slice(4), ...weekDays.slice(0, 4)];
export const validateEmail = (email:string) => {
    return email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
// Class -----------------------------------------------------
export class MyDate extends Date{
    s(){
        return this.toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"});
    }
    ss(){
        return this.toLocaleTimeString("En-US", {timeZone: "America/Los_Angeles"});
    }
};
export class MyFormData extends FormData{
    constructor(args?: HTMLFormElement){
        super(args);
        // Identity now travels in the Authorization: Bearer header (see myAxios).
        // email/version/userName are still sent because internalAuth.php uses them
        // for user-validity and app-version checks (not for authentication).
        this.append("email", user.email);
        this.append("version", user.version);
        this.append("userName", user.userName);
        for(let pair of this.entries()){
            if(typeof(pair[1]) === "string"){
                this.set(pair[0], pair[1].trim());
            }
        }
    }
};
// Functions -----------------------------------------------------
// one-liner
export const calculateDistance = (lat: number, lng: number, center: number[]) => (Math.sqrt(Math.pow((lat - center[0]) * 69, 2) + Math.pow((lng - center[1]) * 54.6, 2)));
export const payRollRuleChangeDate = (date: Date) => (new Date(date.getFullYear() + "/3/31")) < date && date < (new Date(date.getFullYear() + "/11/15"));
export const round = (e: string | number, i: number = 0) => window.Number.parseFloat((typeof(e) === "string"?window.Number.parseFloat(e):e).toFixed(i));
export const onlyUnique = (value: simple, index: number, self: simple[]) => (value !== 0 && !value)?false:(self.indexOf(value) === index);
export const ascSort = (a: simple, b: simple) => a! > b!? 1 : -1;
export const descSort = (a: simple, b: simple) => a! < b!? 1 : -1;
export const objAscSort = (a: json, b: json, sortParameter: string, options: {caseInsensitive: boolean}) => options?.caseInsensitive?(a[sortParameter]?.toLowerCase() > b[sortParameter]?.toLowerCase()? 1 : -1):(a[sortParameter] > b[sortParameter]? 1 : -1);
export const objDescSort = (a: json, b: json, sortParameter: string, options: {caseInsensitive: boolean}) => options?.caseInsensitive?(a[sortParameter]?.toLowerCase() < b[sortParameter]?.toLowerCase()? 1 : -1):(a[sortParameter] < b[sortParameter]? 1 : -1);
export const boolOrReducer = (accumulator: boolean, currentValue: boolean) => accumulator || currentValue;
export const boolAndReducer = (accumulator: boolean, currentValue: boolean) => accumulator && currentValue;
export const numberReducer = (accumulator: number, currentValue: number) => accumulator + currentValue;
export const arrayReducer = (accumulator: any[], currentValue: any[]) => [...accumulator, ...currentValue];
export const objectReducer = (accumulator: json, currentValue: json) => ({...accumulator, ...currentValue});
export const toProperCase = (str: string) => str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
/** Parses JSON that may be normal or double-escaped (e.g. {\\"key\\":\\"val\\"}). */
export const safeParseJson = (value: unknown, fallback: json = {}): json => {
    if (value == null || value === "") return fallback;
    if (typeof value === "object") return value as json;
    if (typeof value !== "string") return fallback;
    try {
        const parsed = JSON.parse(value);
        return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
    } catch {
        try {
            return JSON.parse(value.replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
        } catch {
            return fallback;
        }
    }
};
// normal
export const test = (e:any) => {
    if(isDevMode) console.log(e);
    return e;
}
export const convertNumbersToLetters = (number:number) => {
    const dict = "ZABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let n = number;
    let s = "";
    while(n > 26){
      const m = n % 26;
      s = dict[m] + s;
      n = Math.floor(n / 26);
      if(m === 0) n--;
    }
    return dict[n] + s;
}
export const convertAMPM = (str: string) => {
    if(!str) return str;
    
    // If already in 24-hour format (no AM/PM)
    if (!str.includes("AM") && !str.includes("PM")) {
        // Input from time field is already in 24-hour format, return as is
        return str;
    }
    
    try {
        // Parse 12-hour format with AM/PM
        const parts = str.split(" ");
        if (parts.length !== 2) return str; // Invalid format
        
        const timePart = parts[0];
        const ampm = parts[1];
        
        const timeComponents = timePart.split(":");
        let hours = parseInt(timeComponents[0], 10);
        const minutes = timeComponents[1] || "00";
        const seconds = timeComponents[2] || "00";
        
        // Convert to 24-hour format
        if (ampm === "PM" && hours < 12) {
            hours += 12;
        } else if (ampm === "AM" && hours === 12) {
            hours = 0;
        }
        
        // Format hours with leading zero if needed
        const formattedHours = hours.toString().padStart(2, "0");
        return `${formattedHours}:${minutes}:${seconds}`;
    } catch (e) {
        console.error("Error converting time format:", e);
        return str; // Return original if any error
    }
}

export const convert24 = (str: string) => {
    if(!str) return str;
    
    // If already has AM/PM, return as is
    if (str.includes("AM") || str.includes("PM")) {
        return str;
    }
    
    try {
        // Parse 24-hour format
        const parts = str.split(":");
        if (parts.length < 2) return str; // Invalid format
        
        let hours = parseInt(parts[0], 10);
        const minutes = parts[1] || "00";
        const seconds = parts[2] || "00";
        
        // Convert to 12-hour format with AM/PM
        let ampm = "AM";
        if (hours >= 12) {
            ampm = "PM";
            if (hours > 12) {
                hours -= 12;
            }
        } else if (hours === 0) {
            hours = 12;
        }
        
        return `${hours}:${minutes}:${seconds} ${ampm}`;
    } catch (e) {
        console.error("Error converting time format:", e);
        return str; // Return original if any error
    }
}

export const isDstObserved = (date: Date) => { // unused
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    return date.getTimezoneOffset() < stdTimezoneOffset;
}
export const addDate = (dateString: string, num: number) => {
    if(
        !dateString ||
        dateString === defaultEmptyDate || 
        dateString === defaultEmptyDate.replace(/-/g,"/")
    ) return "";
    const date = new MyDate(dateString.replace(/-/g,"/"));
    date.setDate(date.getDate() + num);
    return date.s();
}
export const usaExpireColorCode = (e: string) => {
    if(e === "") return "";
    const date = new Date(e);
    if(date < new Date()) return "red";
    date.setDate(date.getDate() - 14);
    if(date < new Date()) return "yellow";
    return "rgba(4,170,109,0.8)";
    
}
export const showSize = (number: number) => {
    let n = number;
    if(n < 1024){return n;}
    n = round(String(n / 1024), 2);
    if(n < 1024){return n + " K";}
    n = round(String(n / 1024), 2);
    if(n < 1024){return n + "M";}
    n = round(String(n / 1024), 2);
    if(n < 1024){return n + "G";}
}
export const apiBase = (fileName: string): string => {
    const apiUrlMap: Record<string, string> = {
        "dev.bessusapp.com": `https://besstestapi.t2udev2.com/besstestlab/${fileName}`,
        "localhost": `http://localhost:8080/besstestlab/${fileName}`,
        "127.0.0.1": `http://localhost:8080/besstestlab/${fileName}`,
        "bessusapp.com":     `https://api.bessusapp.com/besstestlab/${fileName}`,
        "app.jmbnexlvl.com": `https://jmbapi.t2uclient2.com/besstestlab/${fileName}`,
    };
    return apiUrlMap[window.location.hostname] ?? `https://api.bessusapp.com/besstestlab/${fileName}`;
};

// Google Drive folder IDs that used to be hardcoded per-brand directly at each
// call site (training.jsx, newspaper.jsx, detail.jsx, mainMenu.jsx, fleets.jsx).
// Centralized here and keyed by hostname, same pattern as apiUrlMap above, so
// adding a brand only means adding one row here instead of editing 6 files.
const driveFolderIdsByBrand: Record<string, Record<string, string>> = {
    besstestlab: {
        training: "1YYIPK8aeucDNiix2o2WMcwQNwcEyZgzm",
        motorVehicleRecord: "1blsYyzY5ibXGtJCwIU-iEeN8weSFmSfk",
        newspaperRoot: "1VvtNEhSH6Uak4bjEnGw6KsURoRtRYclv",
        documentsRoot: "1OoKSZgOmFopcN9uAfLY_SKXkZnFC8JQy",
        safetyRoot: "1UnqV9cJFJ2dJk6_as1cn77HMz3V5xoQP",
        insuranceCard: "1hyCkacg43n9Vg5LeXuFGZUwiYJN392PB",
        registrationCard: "1R7HxI3VHacf9Msi3RleU16tSWSh6OvPf",
    },
    jmb: {
        training: "1qH5Wz0n840sQd0S7cFew_BVDmODGHDA1",
        motorVehicleRecord: "1eGtuwuXb-kdZPNSKiE9vb1pqwdX0jdtQ",
        newspaperRoot: "1R8TTV0oBsmT51Os2SS8_gjKCh4z9MFiV",
        documentsRoot: "18rvv9l6uRadeQPqf7_ghe3DpU0uQBlIn",
        safetyRoot: "1EsHXyl17Y54S_08YBpLr5oFMKV0jBgUr",
        insuranceCard: "1C3VArQmngNr6gz_SvVNrLuG8BCJuHj8z",
        registrationCard: "1dgJIGbdL_mFm8MiHGdxlLZqK0b6eUcWx",
    },
};
export const getDriveFolderId = (key: keyof typeof driveFolderIdsByBrand["besstestlab"]): string => {
    const brand = isJmbBrand ? "jmb" : "besstestlab";
    return driveFolderIdsByBrand[brand][key];
};

// Brand logo, same hostname pattern as apiUrlMap/getDriveFolderId. Used for the
// header logo, login page logo, and map marker icon — all share one image per
// brand today; add distinct variants here if a brand ever needs different crops.
export const getBrandLogo = (): string => {
    return isJmbBrand ? jmbLogoImg : bessLogoImg;
};

// Single-flight refresh: if several requests 401 at once, they all await ONE
// /auth/refresh call instead of stampeding the endpoint (and rotating the cookie
// multiple times). Returns true and stores the new access token on success.
let refreshPromise: Promise<boolean> | null = null;
export const refreshAccessToken = async (): Promise<boolean> => {
    if (!refreshPromise) {
        refreshPromise = axios({
            method: "post",
            url: apiBase("auth/refresh.php"),
            withCredentials: true,
        })
        .then((res: any) => {
            if (res?.data?.code && res.data.accessToken) {
                setAccessToken(res.data.accessToken);
                return true;
            }
            return false;
        })
        .catch(() => false)
        .finally(() => { refreshPromise = null; });
    }
    return refreshPromise;
};

// Clear auth state; PrivateRoute then redirects to /Login on next render.
const handleAuthFailure = () => {
    clearAccessToken();
    try { useMyStore.getState().setAuthenticated(false); } catch (e) { /* store not ready */ }
};

// Boot-time silent login: restore the session from the HttpOnly refresh cookie
// (no password). Returns true if authenticated. Called once on app mount.
export const bootstrapAuth = async (): Promise<boolean> => {
    const store = useMyStore.getState();
    // Ensure we know the latest app version first — MyFormData sends it and
    // internalAuth.php rejects stale versions. (Login screen fetches it otherwise.)
    if (!user.version) {
        try {
            const vres: any = await axios({
                method: "post",
                url: apiBase("auth/getVersion.php"),
                data: new FormData(),
                withCredentials: true,
            });
            if (vres?.data) {
                user.version = vres.data.version;
                user.versionMessage = vres.data.message;
            }
        } catch (e) { /* non-fatal; login screen will retry */ }
    }
    // Attempt the silent refresh.
    try {
        const res: any = await axios({
            method: "post",
            url: apiBase("auth/refresh.php"),
            withCredentials: true,
        });
        if (res?.data?.code && res.data.accessToken && res.data.user) {
            setAccessToken(res.data.accessToken);
            const u = res.data.user;
            for (const key of Object.keys(u)) {
                // keep our coords + the latest app version (not the stored one)
                if (key !== "coords" && key !== "version") user[key] = u[key];
            }
            // If the latest-version prefetch failed for any reason, fall back to
            // the user's stored version from refresh.php so the boot-hydrated
            // session still has a non-empty version for UI + MyFormData.
            if (!user.version && u.version) user.version = u.version;
            user.email = u.email;
            store.setUserInfo(user);
            store.setAuthenticated(true);
            return true;
        }
    } catch (e) { /* no valid cookie -> show login */ }
    return false;
};

export type MyAxiosErrorResult = {
    __myAxiosError: true,
    message: string,
    fatal?: boolean
};
export const myAxios = async(
    fileName: string, 
    formData?: MyFormData, 
    responseType?: ResponseType, 
    signal?: GenericAbortSignal,
    withCredentials: boolean = true, // Default to true
    options?: { silent?: boolean }
) => {
    const silent = options?.silent === true;
    const asError = (message: string, fatal?: boolean): MyAxiosErrorResult | false => {
        if(silent){
            return { __myAxiosError: true, message, ...(fatal ? { fatal: true } : {}) };
        }
        return false;
    };
    if(formData === undefined){
        formData = new MyFormData();
    }
    if(!window.navigator.onLine){
        if(!silent) window.alert(`You are offline, please try later.`);
        return asError("You are offline, please try later.", true);
    }
    const apiUrl = apiBase(fileName);
    // Performs the request with the current access token; resolves to the axios
    // response on success or to the axios error object on failure (we inspect it).
    const attempt = (): Promise<any> => axios({
        method: "post",
        url: apiUrl,
        headers: {
            "Content-Type": "multipart/form-data",
            ...(getAccessToken() ? { Authorization: `Bearer ${getAccessToken()}` } : {}),
        },
        data: formData,
        responseType: responseType,
        signal: signal,
        withCredentials: withCredentials
    }).catch((e: any) => e);

    const statusOf = (r: any) => r?.response?.status ?? r?.status;
    const errorCodeOf = (r: any) => r?.response?.data?.error ?? r?.data?.error;

    let res: any = await attempt();

    // Access token expired -> refresh once (single-flight) and retry the request.
    if (errorCodeOf(res) === "token_expired") {
        const refreshed = await refreshAccessToken();
        if (refreshed) {
            res = await attempt();
        } else {
            handleAuthFailure();
            return asError("Session expired.", true);
        }
    }

    // Still an axios error (not a normal response)?
    if (res?.isAxiosError || res instanceof Error) {
        const e: any = res;
        if (statusOf(e) === 401) { // unauthorized beyond the handled-expiry case
            handleAuthFailure();
            return asError("Unauthorized.", true);
        }
        if(e.message === "Network Error" || e.message === "timeout of 0ms exceeded" || e.message === "timeout exceeded"){
            if(!silent) window.alert(`Bad connection or server is busy, please try again.\n(You can try Chrome browser if you are not using it.)`);
            return asError("Bad connection or server is busy.");
        }else if(e.message === "canceled"){ 
            return asError("canceled", true);
        }else{ 
            if(!silent) window.alert(`${e} at ${fileName}\n\n(Please screenshot this and send to IT.)`);
            return asError(`${e} at ${fileName}`);
        }
    }

    if(res && res.status === 230){
        if(!silent) alert(res.data);
        return asError(typeof res.data === "string" ? res.data : String(res.data ?? "Server error (230)"));
    }
    return res;
}
export const post_max_size = 8 * 1024 * 1024; // PHP_INI_PERDIR
export const handleFilesInput = (e: SyntheticEvent) => {
    const event = e.nativeEvent;
    const target = event.target as HTMLInputElement;
    const files = target.files!;
    if(files.length === 0) return;
    const nextElementSibling = target.nextElementSibling! as HTMLLabelElement;
    // const type = target.accept;
    let size = 0;
    if(files.length === 1){
        size = files[0].size;
        if(files[0].size < 100 * 1024){
            if(!window.confirm(`The file size (${(files[0].size / 1024).toFixed(2)}k) is too small (less than 100k). Are you sure to upload?\n(Images can be selected as Medium or Large for better quality.)`)){
                target.value = "";
                nextElementSibling.innerText = "Choose file(s)";
                return;
            }
        }
    }else if(files.length > 1){
        for(const file of files){
            size += file.size;
            if(file.size < 100 * 1024){
                if(!(window.confirm(`One of the file size (${(file.size / 1024).toFixed(2)}k) is too small (less than 100k). Are you sure to upload?\n(Images can be selected as Medium or Large for better quality.)`)!)){
                    target.value = "";
                    nextElementSibling.innerText = "Choose file(s)";
                    return;
                }
            }
        }
    }
    if(size > post_max_size){
        const upload_size_in_M = round(size / 1024 / 1024, 2);
        const post_max_size_in_M = round(post_max_size / 1024 / 1024);
        if(!window.confirm(`Upload size (${upload_size_in_M}M) exceed max allowable size ${post_max_size_in_M}M. Still Proceed? (This may cause error.)`)){
            target.value = "";
            nextElementSibling.innerText = "Choose file(s)";
            return;
        }
    }
    if(files.length === 1){
        nextElementSibling.innerText = files[0].name;
    }else if(files.length === 0){
        nextElementSibling.innerText = "Choose file(s)";
    }else{
        nextElementSibling.innerText = `${files.length} file(s)`;
    }
}
export const addslashes = (str: string | undefined) => {
    if(str === undefined) return "";
    return str.replace(/\\/g, '\\\\')
        //.replace(/\u0008/g, '\\b')
        .replace(/\t/g, '\\t')
        .replace(/\n/g, '\\n')
        .replace(/\f/g, '\\f')
        .replace(/\r/g, '\\r')
        .replace(/'/g, '\\\'')
        .replace(/"/g, '\\"');
}
export const scroll = (id?: string | null) => {
    if(id === undefined){
        return;
    }else if(id === null){
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    }else{
        const interval = setInterval(() => {
            if(document.getElementById(id)){
                setTimeout(() => {
                    document.getElementById(id)?.scrollIntoView({
                        behavior: "smooth", block: "start"
                    });
                }, 200);
            }
        }, 200);
        setTimeout(() => {
            clearInterval(interval);
        }, 400);
    }
}
export const getJsonArray = (e: string) => {
    try{
        return JSON.parse(e);
    }catch(error){
        window.alert("System error occurred on your files.");
        return [];
    }
}
export const statusColorCode = (status: string, workStatus?: string) => {
    switch(status){
        case "Created":
            return "red";
        case "Saved":
            return "purple";
        case "Submitted":
            if(workStatus !== undefined && workStatus !== "Work"){
                return "gray"
            }else{
                return "green";
            }
        case "Rejected":
            return "blue";
        default:
            return "black";
    }
}
export const weeknum = (date_string: Date | string) => {
    if(!date_string) return "";
    let res: string;
    if(date_string instanceof MyDate){
        res = date_string.s().replace(/-/g, "/");
    }else if(date_string instanceof Date){
        res = date_string.toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}).replace(/-/g, "/");
    }else{
        res = date_string;
    }
    const target = new Date(res.substring(0, 10).replace(/-/g, "/"));
    const dayNr = (target.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    const firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
        target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }
    const number = 1 + Math.ceil((firstThursday - target.valueOf()) / 604800000);
    const year = target.getFullYear();
    const result = "w" + year + "-" + (number < 10? "0" + number.toString(): number.toString());
    return result;
}
export const changeWeek = (week: string, numberWeeks: number) => {
    const target = getDatefromWeekNum0(week, 1)!;
    target.setDate(target.getDate() + 7 * numberWeeks);
    return weeknum(target);
}
export const getMonthfromWeekNum = (week: string, dayNum: number) => {
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
   return month[(new Date(year, 0, days)).getMonth()];
}
export const getDatefromWeekNum0 = (week: string, dayNum: number) => {
    if(!week) return;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    return new MyDate(year, 0, days);
}
export const getDatefromWeekNum = (week: string, dayNum: number) => {
    if(!week) return;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    return (new MyDate(year, 0, days)).s();
}
export const getDateEndFromWeekNum = (week: string) => {
    if(!week) return;
    const dayNum = 6;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    const date_string = (new MyDate(year, 0, days)).s();
    const newYear = date_string.substring(0, 4);
    const newMonth = date_string.substring(5, 7);
    const newDay = date_string.substring(8, 10);
    return `WE ${newMonth}-${newDay}-${newYear}`;
}
export const getDateEndFromWeekNum2 = (week: string) => {
    if(!week) return;
    const dayNum = 6;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    const date_string = (new MyDate(year, 0, days)).s();
    const newYear = date_string.substring(0, 4);
    const newMonth = date_string.substring(5, 7);
    const newDay = date_string.substring(8, 10);
    return `${newYear}/${newMonth}/${newDay}`;
}
export const getDateTime = (week: string, dayNum: number, hours: number, minutes: number) => {
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    const deadline = new Date(year, 0, days);
    deadline.setHours(hours);
    deadline.setMinutes(minutes);
    return deadline;
}
export const timepicker = (obj?: {unitTime?: number, startIndex: number, timeLength: number}) => {
    let validUnitTime = 15;
    let validStartIndex = 0;
    let validTimeLength = 96;
    const unitTime = obj!?.unitTime ?? validUnitTime;
    const startIndex = obj!?.startIndex;
    const timeLength = obj!?.timeLength;
    if(Number.isInteger(unitTime) && !(60 % unitTime)){
        validUnitTime = unitTime;
    }
    const len = 60 / validUnitTime;
    const h12 = [
        "12", "01", "02", "03", "04", "05", 
        "06", "07", "08", "09", "10", "11"
    ];
    const h24 = [
        "00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", 
        "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"
    ];
    const ampm = ["AM", "PM"];
    const mins = [];
    for(let i = 0; i < len; i++){
        if(i * validUnitTime < 10){
            mins.push(0 + String(i * validUnitTime));
        }else{
            mins.push(String(i * validUnitTime));
        }
    }
    const timepickerArr = [];
    for(let k = 0; k < ampm.length; k++){
        for(let i = 0; i < h12.length; i++){
            for(let j = 0; j < mins.length; j++){
                timepickerArr.push({
                    text:`${h12[i]}:${mins[j]} ${ampm[k]}`, 
                    value:`${h24[k>0?i+12:i]}:${mins[j]}`
                });
            }
        }
    }
    if(Number.isInteger(startIndex)){
        validStartIndex = startIndex;
    }
    if(Number.isInteger(timeLength)){
        validTimeLength = timeLength;
    }
    if(validStartIndex + validTimeLength > 96){
        return [
            ...timepickerArr.slice(validStartIndex, validTimeLength),
            ...timepickerArr.slice(0, validStartIndex + validTimeLength - 96).map(time => ({text: "next day " + time.text, value: "12/31/1899 " + time.value + ":00"}))
        ];
    }else{
        return timepickerArr.slice(validStartIndex, validTimeLength);
    }
}
export const buildWeekNumArray = (start: string, end?: string) => {
    const res = [];
    const min = new Date(start.replace(/-/g, "/"));
    const max = (end && end !== defaultEmptyDate)?new Date(end.replace(/-/g, "/")):new Date();
    while(min < max){
        res.push(weeknum(min));
        min.setDate(min.getDate() + 7);
    }
    if(
        !res.includes(weeknum(max))
        // && (!res.length || getDateEndFromWeekNum(weeknum(max)) !== getDateEndFromWeekNum(res[res.length - 1]))
    ){
        
        res.push(weeknum(max));
    }
    return res;
}
// internal(helper) function
const getCustomDate = (year: number, month: number, week: number, day: number) => { // internal use
    let firstDay = 1;
    if(week < 0){
        month++;
        firstDay--;
    }
    const date = new MyDate(year, month, (week * 7) + firstDay);
    if(day < date.getDay()){
        day += 7;
    }
    date.setDate(date.getDate() - date.getDay() + day);
    return date.s();
}
export const dateDurationCalc = (start:string, end:string) => {
    if(start === end) return "1 day"; // easy computation
    const from = new Date(start.replace(/-/g, "/"));
    const to = new Date(end.replace(/-/g, "/"));
    let n = Math.ceil((to.getTime() - from.getTime()) / (1000 * 3600 * 24));
    from.setDate(from.getDate() + n);
    if(from.getDate() !== to.getDate()){
        from.setDate(from.getDate() + 1);
        n++;
        if(from.getDate() !== to.getDate()){
            from.setDate(from.getDate() - 2);
            n -= 2;
        }
    }
    return String(n + 1) + " days";
}
export const timeDurationCalc /* result in minutes */ = (start:string, end:string) => ((new Date(`2021/5/10 ${end}`)).getTime() - (new Date(`2021/5/10 ${start}`)).getTime()) / 60000;
export const getFirstNonLunchIndex = (dayData: {data: any}) => {
    const jobs = dayData.data;
    for(let i = 0; i < jobs.length; i++){
        if(jobs[i].category !== "lunch" && !["02055506", "02051446", defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = 0; i < jobs.length; i++){
        if(jobs[i].category !== "lunch" && ![defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = 0; i < jobs.length; i++){
        if(jobs[i].category !== "lunch"){
            return i;
        }
    }
    return false;
}
export const getLastNonLunchIndex = (dayData: {data: any}) => {
    const jobs = dayData.data;
    for(let i = jobs.length - 1; i >= 0; i--){
        if(jobs[i].category !== "lunch" && !["02055506", "02051446", defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = jobs.length - 1; i >= 0; i--){
        if(jobs[i].category !== "lunch" && ![defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = jobs.length - 1; i >= 0; i--){
        if(jobs[i].category !== "lunch"){
            return i;
        }
    }
    return false;
}
const calcMob = (obj: {mobInTime: number, mobOutTime: number, regular: number, ot: number, mobInFrom: string, mobOutTo: string}) => {
    let regular = 0, ot = 0, regular1 = 0, regular2 = 0, ot1 = 0, ot2 = 0;
    const mobIn = round(obj.mobInFrom === "Hotel"?obj.mobInTime / 60 : Math.max(obj.mobInTime - 60, 0) / 60, 2);
    const mobOut = round(obj.mobOutTo === "Hotel"?obj.mobOutTime / 60 : Math.max(obj.mobOutTime - 60, 0) / 60, 2);
    if(mobIn > obj.regular){
        regular += obj.regular;
        regular1 += obj.regular;
        ot += mobIn - obj.regular;
        ot1 += mobIn - obj.regular;
    }else{
        regular += mobIn;
        regular1 += mobIn;
    }
    if(mobOut > obj.ot){
        ot += obj.ot;
        ot2 += obj.ot;
        regular += mobOut - obj.ot;
        regular2 += mobOut - obj.ot;
    }else{
        ot += mobOut;
        ot2 += mobOut;
    }
    return {regular, ot, regular1, regular2, ot1, ot2};
}
const calcStandByTime = (start: string, end: string, AllOT: boolean) => {
    let regular = 0, ot = 0;
    if(AllOT){
        ot = round(timeDurationCalc(start, end) / 60, 2);
    }else{
        if(start <= "07:00" && end <= "07:00"){
            ot = round(timeDurationCalc(start, end) / 60, 2);
        }else if("07:00" <= start && start <= "15:30" && "07:00" <= end && end <= "15:30"){
            regular = round(timeDurationCalc(start, end) / 60, 2);
        }else if(start >= "15:30" && end >= "15:30"){
            ot = round(timeDurationCalc(start, end) / 60, 2);
        }else if(start <= "07:00" && "07:00" <= end && end <= "15:30"){
            ot = round(timeDurationCalc(start, "07:00") / 60, 2);
            regular = round(timeDurationCalc("07:00", end) / 60, 2);
        }else if(start <= "07:00" && end >= "15:30"){
            ot = round(timeDurationCalc(start, "07:00") / 60 + timeDurationCalc(end, "15:30") / 60, 2);
            regular = round(timeDurationCalc("07:00", "15:30") / 60, 2);
        }else if("07:00" <= start && start <= "15:30" && end >= "15:30"){
            regular = round(timeDurationCalc(start, "15:30") / 60, 2);
            ot = round(timeDurationCalc("15:30", end) / 60, 2);
        }else{
            console.log(start, end);
        }
    }
    return { regular, ot };
}
export const calcLocate = (
    curData: {
        data: {
            start: string, 
            end: string, 
            mins: number, 
            category: string, 
            regular: number, 
            ot: number, 
            pmNumber: string
        }[], 
        mobInTime: number, 
        mobInTimeEffective: number, 
        mobInTimePM: string, 
        mobOutTime: number, 
        mobOutTimeEffective: number, 
        mobOutTimePM: string, 
        workTime: number, 
        mobInStart: string, 
        mobInEnd: string, 
        mobOutStart: string, 
        mobOutEnd: string, 
        lunchTime: number, 
        mobInFrom: string, 
        mobOutTo: string, 
        regular: number, 
        ot: number, 
        mobReg: number, 
        mobInReg: number,
        mobOutReg: number,
        mobOT: number, 
        mobInOT: number, 
        mobOutOT: number, 
        workStatus: string, 
        status: string
    }, 
    dayNum: number, 
    dateString: string, 
    outside: string, 
) => {
    let rawData = curData;
    
    const firstNonLunchIndex = getFirstNonLunchIndex(rawData);
    const lastNonLunchIndex = getLastNonLunchIndex(rawData);
    if(firstNonLunchIndex === false) return rawData;
    if(lastNonLunchIndex === false) return rawData;
    if(rawData.workStatus !== "Work") return rawData;
    if(rawData.status !== "Submitted") return rawData;
    const allOT = dayNum > 4 || outsideHolidays.map(h => h.date).includes(dateString);
    if(outside === "locator"){
        rawData.mobInTime = timeDurationCalc(rawData.mobInStart, rawData.mobInEnd);
        rawData.mobInTimePM = rawData.data[firstNonLunchIndex].pmNumber;
        rawData.mobOutTime = timeDurationCalc(rawData.mobOutStart, rawData.mobOutEnd);
        rawData.mobOutTimePM = rawData.data[lastNonLunchIndex].pmNumber;
        rawData.workTime = timeDurationCalc(rawData.mobInEnd, rawData.mobOutStart);
        rawData.data = rawData.data.map(d => ({...d, mins: timeDurationCalc(d.start, d.end)}));
        if(rawData.data.find(d => d.category === "lunch")){
            rawData.lunchTime = rawData.data
            .filter(d => d.category === "lunch")
            .reduce((a, b) => ({mins:(a.mins + b.mins)}), {mins: 0}).mins;
            rawData.workTime -= rawData.lunchTime;
        }else{
            rawData.lunchTime = 0;
        }
        if(rawData.mobInFrom === "Hotel"){
            // rawData.data[firstNonLunchIndex].mins += rawData.mobInTime;
            rawData.workTime += rawData.mobInTime;
        }else{
            if(rawData.mobInTime > 60){
                // rawData.data[firstNonLunchIndex].mins += rawData.mobInTime - 60;
                rawData.workTime += rawData.mobInTime - 60;
            }
        }
        if(rawData.mobOutTo === "Hotel"){
            // rawData.data[lastNonLunchIndex].mins += rawData.mobOutTime;
            rawData.workTime += rawData.mobOutTime;
        }else{
            if(rawData.mobOutTime > 60){
                // rawData.data[lastNonLunchIndex].mins += rawData.mobOutTime - 60;
                rawData.workTime += rawData.mobOutTime - 60;
            }
        }
        rawData.regular = 0;
        rawData.ot = 0;
        if(allOT){
            if(rawData.workTime <= 2 * 60){
                rawData.ot = 2;
                rawData.data[lastNonLunchIndex].mins += 2 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 4 * 60){
                rawData.ot = 4;
                rawData.data[lastNonLunchIndex].mins += 4 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 6 * 60){
                rawData.ot = 6;
                rawData.data[lastNonLunchIndex].mins += 6 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 8 * 60){
                rawData.ot = 8;
                rawData.data[lastNonLunchIndex].mins += 8 * 60 - rawData.workTime;
            }else{
                rawData.ot = round(rawData.workTime / 60, 2);
            }
        }else{
            if(rawData.workTime <= 2 * 60){
                rawData.regular = 2;
                rawData.data[lastNonLunchIndex].mins += 2 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 4 * 60){
                rawData.regular = 4;
                rawData.data[lastNonLunchIndex].mins += 4 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 6 * 60){
                rawData.regular = 6;
                rawData.data[lastNonLunchIndex].mins += 6 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 8 * 60){
                rawData.regular = 8;
                rawData.data[lastNonLunchIndex].mins += 8 * 60 - rawData.workTime;
            }else{
                rawData.regular = 8;
                rawData.ot = round(rawData.workTime / 60, 2) - 8;
            }
        }
        const {regular, ot, regular1, regular2, ot1, ot2} = calcMob(rawData);
        rawData.mobReg = regular;
        rawData.mobInReg = regular1;
        rawData.mobOutReg = regular2;
        rawData.mobOT = ot;
        rawData.mobInOT = ot1;
        rawData.mobOutOT = ot2;
        if(Number.isNaN(rawData.ot) || Number.isNaN(rawData.ot)) console.log(rawData);
    }else if(["standby", "qew"].includes(outside)){
        rawData.mobInTime = timeDurationCalc(rawData.mobInStart, rawData.mobInEnd);
        rawData.mobInTimePM = rawData.data[firstNonLunchIndex].pmNumber;
        rawData.mobOutTime = timeDurationCalc(rawData.mobOutStart, rawData.mobOutEnd);
        rawData.mobOutTimePM = rawData.data[lastNonLunchIndex].pmNumber;
        rawData.workTime = timeDurationCalc(rawData.mobInEnd, rawData.mobOutStart);
        rawData.data = rawData.data.map(d => ({...d, mins: timeDurationCalc(d.start, d.end)}));
        if(rawData.data.find(d => d.category === "lunch")){
            rawData.lunchTime = rawData.data
            .filter(d => d.category === "lunch")
            .reduce((a, b) => ({mins:(a.mins + b.mins)}), {mins: 0}).mins;
            rawData.workTime -= rawData.lunchTime;
        }else{
            rawData.lunchTime = 0;
        }
        // rawData.data[firstNonLunchIndex].mins += rawData.mobInTime;
        rawData.workTime += rawData.mobInTime;
        // rawData.data[lastNonLunchIndex].mins += rawData.mobOutTime;
        rawData.workTime += rawData.mobOutTime;
        rawData.regular = 0;
        rawData.ot = 0;
        rawData.mobReg = 0;
        rawData.mobOT = 0;
        for(const [index, {start, end, category}] of rawData.data.entries()){
            if(category === "lunch") continue;
            const {regular, ot} = calcStandByTime(start, end, allOT);
            rawData.data[index].regular = regular;
            rawData.data[index].ot = ot;
            rawData.regular += regular;
            rawData.ot += ot;
        }
        const mobInTime = calcStandByTime(rawData.mobInStart, rawData.mobInEnd, allOT);
        const mobOutTime = calcStandByTime(rawData.mobOutStart, rawData.mobOutEnd, allOT);
        // rawData.data[firstNonLunchIndex].regular += mobInTime.regular;
        rawData.mobInReg = mobInTime.regular;
        rawData.mobReg += mobInTime.regular;
        rawData.regular += mobInTime.regular;
        // rawData.data[firstNonLunchIndex].ot += mobInTime.ot;
        rawData.mobInOT = mobInTime.ot;
        rawData.mobOT += mobInTime.ot;
        rawData.ot += mobInTime.ot;
        // rawData.data[lastNonLunchIndex].regular += mobOutTime.regular;
        rawData.mobOutReg = mobOutTime.regular;
        rawData.mobReg += mobOutTime.regular;
        rawData.regular += mobOutTime.regular;
        // rawData.data[lastNonLunchIndex].ot += mobOutTime.ot;
        rawData.mobOutOT = mobOutTime.ot;
        rawData.mobOT += mobOutTime.ot;
        rawData.ot += mobOutTime.ot;
        if(allOT){
            if(rawData.ot <= 2){
                rawData.data[lastNonLunchIndex].ot += 2 - rawData.ot;
                rawData.ot = 2;
            }else if(rawData.ot <= 4){
                rawData.data[lastNonLunchIndex].ot += 4 - rawData.ot;
                rawData.ot = 4;
            }else if(rawData.ot <= 6){
                rawData.data[lastNonLunchIndex].ot += 6 - rawData.ot;
                rawData.ot = 6;
            }else if(rawData.ot <= 8){
                rawData.data[lastNonLunchIndex].ot += 8 - rawData.ot;
                rawData.ot = 8;
            }
        }else{
            if(rawData.regular <= 2){
                rawData.data[lastNonLunchIndex].regular += 2 - rawData.regular;
                rawData.regular = 2;
            }else if(rawData.regular <= 4){
                rawData.data[lastNonLunchIndex].regular += 4 - rawData.regular;
                rawData.regular = 4;
            }else if(rawData.regular <= 6){
                rawData.data[lastNonLunchIndex].regular += 6 - rawData.regular;
                rawData.regular = 6;
            }else if(rawData.regular <= 8){
                rawData.data[lastNonLunchIndex].regular += 8 - rawData.regular;
                rawData.regular = 8;
            }
        }
    }
    return rawData;
}
export const calcEmergencyLocate = (
    curData: {
        data: any[], 
        workTime: number, 
        ot: number, 
        status: string,
        overnight: boolean
    }
) => {
    const rawData = curData;
    if(rawData.status !== "Submitted") return rawData;
    rawData.workTime = timeDurationCalc(rawData.data[rawData.data.length - 1].start, rawData.data[rawData.data.length - 1].end);
    if(rawData.overnight) rawData.workTime += 60 * 24;
    rawData.data = rawData.data.map(d => 
        ({...d, mins: timeDurationCalc(d.start, d.end) + d.shiftOvernight?60 * 24:0})
    );
    rawData.ot = 0;
    if(rawData.workTime <= 4 * 60){
        rawData.ot = 4;
    }else{
        rawData.ot = round(rawData.workTime / 60, 2); // no
    }

    return rawData;
}
// Components -----------------------------------------------------
export function OtherStyle({
    title, 
    others, 
    setOthers, 
    before
}:{
    title: string, 
    others: json, 
    setOthers: ss<json>
    before?: boolean
}){
    return(
        <>
        <div className = "d-flex align-items-center mb-2">
            <input
                id = {`${title}Others`}
                type = "checkbox"
                checked = {others[title] || false}
                value = "Others"
                className = {`checkboxSquare${before?" ml-3":""}`}
                onChange = {e => {
                    setOthers({...others, [title]:e.currentTarget.checked});
                }}
            />
            <label htmlFor = {`${title}Others`} className = "ml-2">Others</label>
        </div>
        {others[title]?
        <>
        <input
            key = {`${title}`}
            required
            placeholder = "Please specify"
            className = "form-control ml-3"
            name = {`${title}[]`}
            value = {others[`${title}Content`] || ""}
            onChange = {e => setOthers({...others, [`${title}Content`]:e.currentTarget.value})}
        />
        </>:null}
        </>
    ) 
}
export function MenuList({
    options, 
    children, 
    maxHeight, 
    getValue
}:{
    options: jsonArr, 
    children: [], 
    maxHeight: number, 
    getValue: Function
}
){
    const height = 35;
    const [value] = getValue(); // undefined
    const initialOffset = (options.indexOf(value) || 0) * height;
    // const maxLength = Math.max(...children.map(child => child.props.data.label.length as any));
    return (
    <List
        height = {maxHeight}
        width = {""}
        style = {{whiteSpace: "nowrap"}}
        itemCount = {children.length || 0}
        itemSize = {height}
        initialScrollOffset = {initialOffset}
    >
        {({ index, style }) => <div style = {style}>{children[index]}</div>}
    </List>
    );
}
export function Select({...rest}){
    //name is required for required
    return (
        <div style = {rest.divStyle}>
            <OriginSelect
                components = {{MenuList} as any} // no idea
                styles = {{
                    menu: base => ({...base, zIndex: 2}),
                    container: base => ({
                    ...base,
                    flex: 1
                    })
                }}
                isClearable = {rest.isClearable ?? true}
                {...rest}
            />
            {rest.name?
            <input
                tabIndex = {-1}
                autoComplete = "off"
                style = {{ opacity: 0, height: 0 , position: "absolute"}}
                onFocus = {e => (e.currentTarget?.previousSibling?.childNodes?.[2]?.childNodes?.[0]?.childNodes?.[1]?.childNodes?.[0]! as HTMLInputElement).focus()}
                required = {rest.required ?? false}
                readOnly
                name = {rest.name}
                value = {
                    rest.isMulti?
                        (!rest.value || rest.value.length === 0?
                            ""
                            :
                            "undefined"
                        )
                        :
                        (rest.value?.value ?? "")
                }
            />
            :<></>}
        </div>
    );
}
export function FileInput({name, id, accept}:{name: string, id: string, accept: keyof mimeTypeMapType}){
    return <div className = "custom-file">
        <input
            type = "file"
            accept = {mimeTypeMap[accept] ?? ""}
            className = {"custom-file-input"}
            id = {id}
            name = {name}
            onChange = {handleFilesInput}
        />
        <label className = "custom-file-label">
            Choose file
        </label>
    </div>
}
//-----------------------------------------------------
const today = new Date();
const yyyy = today.getFullYear(); 

// const getNumberOfWeekDay = (year:number, month:number, weekDay:number) => {
//     let firstDay = 1;
//     const date = new MyDate(year, month, firstDay);
//     let dayIndex = date.getDay();
//     if(dayIndex > weekDay){
//         dayIndex -= 7;
//     }
//     date.setDate(date.getDate() + weekDay - dayIndex);
//     let count = 1;
//     while(date.getMonth() === month){
//         date.setDate(date.getDate() + 7);
//         count++;
//     }
//     count--;
//     date.setDate(date.getDate() - 7);
//     console.log(date);
//     return count;
// }
export const outsideHolidays = [
    {date: `${today.getFullYear()}-01-01`, name: "New Year's Day"},
    {date: getCustomDate(today.getFullYear(), 4, -1, 1), name: "Memorial's Day"},
    {date: `${today.getFullYear()}-07-04`, name: "Independence Day"},
    {date: getCustomDate(today.getFullYear(), 8, 0, 1), name: "Labor Day"},
    {date: `${today.getFullYear()}-11-11`, name: "Veteran's Day"},
    {date: getCustomDate(today.getFullYear(), 10, -1, 4), name: "Thanksgiving Day"},
    {date: getCustomDate(today.getFullYear(), 10, -1, 5), name: "Black Friday"},
    // {date: `${today.getFullYear()}-12-24`, name: "Christmas Eve"},
    {date: `${yyyy}-12-25`, name: "Christmas Day"},
    // {date: `2022-12-26`, name: "Christmas Day"},
    // {date: `2023-11-10`, name: "Veteran's Day"},
    {date: `2025-01-20`, name: "Martin Luther King Jr. Day"}
];
export const officeHolidays = [
    {date: `${today.getFullYear()}-01-01`, name: "New Year's Day"},
    // {date: `2023-01-02`, name: "for New Year's Day"},
    {date: getCustomDate(today.getFullYear(), 1, 2, 1), name: "President's Day"},
    {date: getCustomDate(today.getFullYear(), 4, -1, 1), name: "Memorial Day"},
    {date: `${today.getFullYear()}-07-04`, name: "Independence Day"},
    {date: getCustomDate(today.getFullYear(), 8, 0, 1), name: "Labor Day"},
    {date: getCustomDate(today.getFullYear(), 10, -1, 4), name: "Thanksgiving Day"},
    {date: getCustomDate(today.getFullYear(), 10, -1, 5), name: "Black Friday"},
    {date: `${yyyy}-12-24`, name: "Christmas Eve"},
    {date: `${yyyy}-12-25`, name: "Christmas Day"},
    // {date: `2022-12-26`, name: "for Christmas Day"},
    // {date: `2022-12-30`, name: "for New Year's Eve"},
    {date: `${yyyy}-12-31`, name: "New Year's Eve"}
];

const stnadbyDurationOffset = 0;
const standbyTimeLength = 125;
export const standbyTP = timepicker({startIndex: stnadbyDurationOffset, timeLength: standbyTimeLength});
export const standbyReverseIndex = (str:string) => Math.max(0, standbyTP.findIndex(time => time.value === str));
export const standbyCalculate = (startIndex: number, endIndex: number, isOT: boolean) => {
    if(isOT) return {o: (endIndex - startIndex) * 0.25, s: 0};
    let s = 0, o = 0;
    if(
        (startIndex < 28 && endIndex <= 28) || /* s1e1 */
        (startIndex >= 62 && endIndex > 62) /* s3e3 */
    ){
        o += (endIndex - startIndex) * 0.25;
    }else if(
        startIndex >= 28 && endIndex <= 62 /* s2e2 */
    ){
        s += (endIndex - startIndex) * 0.25;
    }else if(
        startIndex <= 28 && endIndex >= 28 && endIndex <= 62/* s1e2 */
    ){
        o += (28 - startIndex) * 0.25;
        s += (endIndex - 28) * 0.25;
    }else if(
        startIndex >= 28 && startIndex <= 62 && endIndex >= 62 /* s2e3 */
    ){
        s += (62 - startIndex) * 0.25;
        o += (endIndex - 62) * 0.25;
    }else if(
        startIndex <= 28 && endIndex >= 62 /* s1e3 */
    ){
        o += (endIndex - startIndex - 34) * 0.25;
        s += 8.5;
    }
    return {o, s}
}

export const outsideDailydefaultEmptyData = JSON.stringify({
    form: Array(7).fill(
        {
            unlock: false, 
            working: "", 
            notWorkingReason: "", 
            commuteOrHotel: "", 
            division: "", 
            workingOn: "", 
            acknowledged: false, 
            morning: false, 
            afternoon: false,
            doOT: "", 
            otDate: "", 
            otTime: ""
        }
    ), status: "Created"
})

export const outsidePotDefaultEmptyData = JSON.stringify({
    unlock: false, 
    form: Array(7).fill({
        inYard: "", 
        outYard: ""
    }), status: "Created"
});

export const outsideEotDefaultEmptyData = JSON.stringify({
    unlock: false, 
    form: Array(7).fill({
        availablity: ""
    }), status: "Created"
});

export const getTimeStamp = () => (new MyDate()).s() + " " + (new MyDate()).ss();
export const standbyStartDate = "2023-07-17";
export const standbyWeeks = buildWeekNumArray(standbyStartDate).reverse();
export const locatorStartDate = "2021-08-29";
export const locatorWeeks = buildWeekNumArray(locatorStartDate).reverse();
export const officeTimeCardStartDate = "2021-06-07";
export const officeTimeCardWeeks = buildWeekNumArray(officeTimeCardStartDate).reverse();
export const fleetUsageStartStartDate = "2021-03-08";
export const fleetUsageStartWeeks = buildWeekNumArray(standbyStartDate).reverse();
export const defaultPath = "/home/ttwoudev/public_html/bess_test_api/"; //CONVERT TO ENV VAR
export const weekIndexes = [1, 2, 3, 4, 5, 6, 0];
export const plannedTimeExcel = (start:string, end:string, allDay:boolean) => {
    if(start.substring(0, 10) === end.substring(0, 10)){
        //same Day
        if(allDay){
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 10)}
            ]};
        }else{
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 10)},
                {"text": start.substring(10, 16) + " ~ " + end.substring(11, 16)}
            ]};
        }
    }else{
        //overnight
        if(allDay){
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 10)},
                {"text": " ~ "},
                {"font": {"bold": true},"text": end.substring(0, 10)},
            ]};
        }else{
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 16)},
                {"text": " ~ "},
                {"font": {"bold": true},"text": end.substring(0, 16)},
            ]};
        }
    }
}
export const workLogSubmitTimeExcel = (e:string) => {
    return {"richText": [
        {"font": {"bold": true},"text": e.split(" ")[0]},
        {"text": " " + e.split(" ")[1]}
    ]};
}

export const validURL = (str:string) => {
    const pattern = new RegExp("^(https?:\\/\\/)?"+ // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|"+ // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))"+ // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*"+ // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?"+ // query string
        "(\\#[-a-z\\d_]*)?$","i"); //  
    return !!pattern.test(str);
}

export const GeotabApiOptions = {
    rememberMe: true,
    timeout: 10,
    fullResponse: true
}
export const GeotabApiAuthentication = {
    credentials: {
        database: 'besstestlab',
        userName: 'jun@besstestlab.com',
        password: 'perfect909'
    },
    path: 'my.geotab.com'
}